<div class="page-header-title">
  <div class="form-row align-items-center">
    <div class="col col-auto">
      <ng-template #trafficTooltip>
        <span [innerHTML]="getTrafficTooltip"></span>
      </ng-template>
      @if (machineCategoryIcon && !disableStatusMachine()) {
        <div
          (click)="onOpenStatusEventPage($event);"
          [disableTooltip]="!trafficLightClass"
          [ngClass]="trafficLightClass"
          [ngbTooltip]="trafficTooltip"
          container="body"
          class="traffic-light mr-0">
          <img [src]="machineCategoryIcon" alt="">
        </div>
      }
    </div>
    <div class="col">
      <h1 class="h3" [innerText]="pageName"></h1>
    </div>
  </div>
</div>
